module.exports = __webpack_public_path__ + "static/biennale-regular-0af9ae9f889914b7c1d04b0df7768249.otf";